module.exports = __webpack_public_path__ + "static/media/sms-white.6bdb39e6.png";